module.exports = __webpack_public_path__ + "resources/img/img_maxgauge1_m.588746b16f2845f1f3a53ad73aefce84.png";